<template>
    <div class="nav">
        <router-link to="/home/pharmacy/newbutton">
            <el-button style="margin: 10px 0px;padding: 10px 10px" type="primary" class="el-icon-plus"
                       @click="newbutton">新增盘点
            </el-button>

        </router-link>
        <template> 
            <el-table :data="libraryData" border style="width: 100%" :header-cell-style="tableHeaderColor">
                <el-table-column prop="id" label="盘点单号"></el-table-column>
                <el-table-column prop="date" label="盘点日期"></el-table-column>
                <el-table-column prop="checkUserName" label="盘点人"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <!--<el-button  type="string" size="small" style="padding: 3px 3px;background: #dfe6ec" >已审核</el-button>-->
                        <el-tag style="padding: 2px 5px" :type="scope.row.status==='待审核' ? 'danger':'success'">
                            {{scope.row.status}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status=='待审核'">
                            <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
                            <el-button type="text" size="small" @click="audit(scope.row)">审核</el-button>
                            <el-button @click.native.prevent="deleteRow(scope.row)" type="text" size="small">删除
                            </el-button>
                        </div>
                        <div v-if="scope.row.status!='待审核'">
                            <el-button type="text" size="small" @click="checkClick(scope.row)">查看详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <div class="block">
            <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync=Current
                    :page-size=this.Size
                    layout="total,prev, pager, next, jumper"
                    :total=this.total>
            </el-pagination>
        </div>
    </div>

</template>
<script>

  export default {
    name: 'checkStock',
    data() {
      return {
        total: 0,
        Current: 1,
        Size: 10,
        currentPage: 1,
        checkList: [],
        libraryData: [],
        nameT: '',
        ru: ''
      };
    },
    mounted: function () {
      this.getinfo();
    },
    methods: {
      getinfo: function () {
        this.$axios({
          url: '/api/medicine/check/pageNumber/' + this.Current + '/size/' + this.Size,
          method: 'GET'
        }).then(res => {
          this.libraryData = res.data.data.content;
          this.total = res.data.data.totalElements
        }).catch(err => {
          console.log(res.err);
        })
      },
      tableHeaderColor({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return "background-color:#f2f2f2;color: #a4a7af;";
        }
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.Size = val;
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.Current = val;
        this.getinfo();
      },
      //删除方法
      deleteRow(row) {
        console.log(row);
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios({
            url: '/api/medicine/check/' + row.id,
            method: 'DELETE'
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.getinfo();
          }).catch(err => {
            console.log(err.data);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      newbutton() {
        console.log('新增');
      },

      //修改方法
      handleClick(row) {
        console.log(row);
        this.$router.push({path: "./details", query: {ID: row.id,}});
      },
      //查看详情
      checkClick: function (row) {
        let look = row.id;
        this.$router.push({path: "./inventoryAudit", query: {look: look}})
      },
      //审核
      audit: function (row) {
        this.$router.push({path: "./inventoryAudit", query: {id: row.id}})
      },
      onSubmit: function () {

        console.log(this.value2, this.value1, this.numValue)
      }

    },
  }
</script>

<style type="text/css" scoped>
    * {
        padding: 0px;
        margin: 0px;
    }
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .block {
        margin-top: 20px;
        padding-left: 33%;
    }

    .nav {
        width: 98%;
        margin-left: 18px;
        padding-bottom: 50px;
        background-color: white;
    }
</style>



// WEBPACK FOOTER //
// checkStock.vue?4e0bfaa6